import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { initFlowbite } from "flowbite";
import { RouterOutlet } from "@angular/router";

import {
  MaintenanceService,
  MaintenanceStatus,
} from "./core/service/maintenance.service";
import { MaintenanceComponent } from "./pages/maintenance/maintenance.component";
import { Subscription } from "rxjs";
import { LoaderComponent } from "./shared/loader/loader.component";
import { SocketRouteManagerComponent } from "./core/components/socket-route-manager.component";
import { AdminContractSocketToastService } from "./core/service/admin-contract-socket-toast.service";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [
    RouterOutlet,
    LoaderComponent,
],
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit, OnDestroy {
  maintenanceStatus: MaintenanceStatus = { isMaintenanceMode: false };
  private maintenanceSubscription?: Subscription;

  constructor(
    private readonly maintenanceService: MaintenanceService,
    @Inject(PLATFORM_ID) private readonly platformId: Object,
    /** Eagerly registers app-wide contract socket toasts (any route). */
    private readonly adminContractSocketToastService: AdminContractSocketToastService,
  ) {}

  ngOnInit(): void {
    // Only initialize Flowbite in browser environment
    if (isPlatformBrowser(this.platformId)) {
      initFlowbite();
    }

    // Subscribe to maintenance status
    this.maintenanceSubscription = this.maintenanceService
      .getMaintenanceStatus()
      .subscribe((status) => {
        this.maintenanceStatus = status;
      });
  }

  ngOnDestroy(): void {
    if (this.maintenanceSubscription) {
      this.maintenanceSubscription.unsubscribe();
    }
  }
}
